export default __webpack_public_path__ + "static/media/scratch5.f09a5d95.mp3";